import { Box, Tooltip, Typography } from '@mui/material';
import TagList from './TagList';

type SignalData = {
  sentiment?: string;
  sentiment_description?: string;
  severity?: string;
  severity_description?: string;
};

const chipSx = {
  display: 'inline-block',
  px: 1.2,
  py: 0.5,
  borderRadius: 10,
  bgcolor: '#F3F4F6',
  fontSize: 12
};

export default function SignalsPanel({
  signalData,
  keywords,
  workflows,
  taskCompleted
}: {
  signalData: SignalData;
  keywords: string[];
  workflows: string[];
  taskCompleted: string[];
}) {
  return (
    <Box
      sx={{
        border: '1px solid #ECECEC',
        borderRadius: '8px',
        p: 2,
        mb: 2,
        background: '#fff'
      }}
    >
      <Typography mb={1} fontSize={16} fontWeight={500}>
        Signals
      </Typography>

      <Typography variant='caption' color='text.secondary'>
        Sentiment
      </Typography>
      <Box mt={0.5} mb={1.5}>
        {signalData?.sentiment ? (
          <Tooltip
            title={signalData.sentiment_description}
            placement='top'
            arrow
            componentsProps={{
              tooltip: {
                sx: {
                  backgroundColor: '#fff',
                  color: '#000',
                  fontSize: '12px',
                  boxShadow: '0px 2px 8px rgba(0,0,0,0.15)',
                  border: '1px solid #E5E7EB'
                }
              },
              arrow: { sx: { color: '#fff' } }
            }}
          >
            <Typography sx={chipSx}>{signalData?.sentiment}</Typography>
          </Tooltip>
        ) : (
          '-'
        )}
      </Box>

      <Typography variant='caption' color='text.secondary'>
        Severity
      </Typography>
      <Box mt={0.5} mb={1.5}>
        {signalData?.severity ? (
          <Tooltip
            title={signalData.severity_description}
            placement='top'
            arrow
            componentsProps={{
              tooltip: {
                sx: {
                  backgroundColor: '#fff',
                  color: '#000',
                  fontSize: '12px',
                  boxShadow: '0px 2px 8px rgba(0,0,0,0.15)',
                  border: '1px solid #E5E7EB'
                }
              },
              arrow: { sx: { color: '#fff' } }
            }}
          >
            <Typography sx={chipSx}>{signalData?.severity}</Typography>
          </Tooltip>
        ) : (
          '—'
        )}
      </Box>

      <Typography variant='caption' color='text.secondary'>
        Keywords
      </Typography>
      <Box mt={0.5} mb={1.5}>
        <TagList items={keywords} />
      </Box>

      <Typography variant='caption' color='text.secondary'>
        Workflows
      </Typography>
      <Box mt={0.5} mb={1.5}>
        <TagList items={workflows} />
      </Box>

      <Typography variant='caption' color='text.secondary'>
        Task completed
      </Typography>
      <Box mt={0.5}>
        <TagList items={taskCompleted} />
      </Box>
    </Box>
  );
}
